import React from 'react';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import TripForm from '@/components/trips/TripForm';
const Dashboard = () => {
  return <DashboardLayout title="Plan Your Trip">
      <div className="space-y-8">
        <div className="bg-white/80 rounded-lg p-5 border border-purple-light shadow-sm">
          <h2 className="text-lg font-semibold text-purple-tertiary mb-2 text-center">Welcome to WeTrippy!</h2>
          <p className="text-gray-700 text-left">
            Create a new trip by filling out the form below. Once your trip is created, you'll be able to:
          </p>
          <ul className="list-disc ml-5 mt-2 space-y-1 text-gray-700">
            <li>Plan your itinerary with daily activities</li>
            <li>Track transportation details</li>
            <li>Manage group expenses</li>
            <li>Share memories with travel companions</li>
            <li>Chat with your travel group</li>
          </ul>
          <p className="mt-3 text-gray-700 text-left">
            After creating your trip, you'll receive a unique trip code that you can share with friends and family to invite them to join your adventure!
          </p>
        </div>
        <TripForm />
      </div>
    </DashboardLayout>;
};
export default Dashboard;